module.exports = __webpack_public_path__ + "static/media/wb.98fd044a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/wb.png
// module id = 1200
// module chunks = 110